import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

// Utils
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import useModal from '../../../../../utils/hooks/useModal';
import PermissionsGate from '../../../../../utils/gate/permissionsGate';
import SCOPE from '../../../../../utils/gate/scope';

// Icons
import { ReactComponent as TrashIcon } from '../../../../../assets/icons/trash.svg';

// Components
import InputField from '../../../../atoms/InputField/InputField';

const MediaEdition = forwardRef(({
  media, handleDeleteMedia,
}, ref) => {
  const { t } = useTranslation();
  const { closeModal } = useModal();

  const formik = useFormik({
    initialValues: {
      name: media.name,
      size: `${Math.round(media.size / 1000)} Ko`,
    },
    onSubmit: () => {},
  });

  useImperativeHandle(
    ref,
    () => ({
      submitForm: () => {
        formik.handleSubmit();
      },
    }),
  );

  const getInput = useCallback((name, isDisabled) => (
    <InputField
      id={`media_edition_${name}`}
      name={name}
      value={formik.values[name]}
      label={t(`medias.edition.form.${name}`)}
      formik={{
        handleChange: formik.handleChange,
        handleBlur: formik.handleBlur,
      }}
      error={formik.errors?.[name] && formik.touched?.[name] ? formik.errors[name] : null}
      isRequired
      disabled={isDisabled}
      className="m-b-20"
    />
  ), [formik]);

  return media ? (
    <div>
      <form>
        {getInput('name', true)}
        {getInput('size', true)}
      </form>

      <PermissionsGate scopes={[SCOPE.delete_pla_media, SCOPE.delete_ownEst_media]}>
        <button
          type="button"
          onClick={() => {
            closeModal();
            setTimeout(() => {
              handleDeleteMedia(media);
            }, 250);
          }}
          className="fw-500 c-error-500 d-flex a-center c-pointer hover-bright m-t-30"
        >
          <TrashIcon className="m-r-10" width={18} height={18} />
          {t('medias.delete.title')}
        </button>
      </PermissionsGate>
    </div>
  ) : null;
});

MediaEdition.propTypes = {
  media: PropTypes.shape({
    name: PropTypes.string,
    fileId: PropTypes.string,
    size: PropTypes.number,
  }).isRequired,
  handleDeleteMedia: PropTypes.func,
};

MediaEdition.defaultProps = {
  handleDeleteMedia: () => {},
};

export default MediaEdition;
